<section class='container mt-4'>
 <h2 class='text-center txtBold'>Nuestros servicios</h2>
 <div class='row d-flex justify-content-center mt-3'>
  <div class='col-5'>
   <img src='assets/img/ourServIndec.svg' alt='imagen servicios Segurnet' >
  </div>
  <div class='col-7 d-flex flex-wrap align-content-center'>
   <p class='text-uppercase txtBold txt12px'>Resguardamos la <span class='txtSegu'>seguridad</span><br><span class='txtcomf'>de nuestros clientes</span><br>con <span class='txtSegu'>excelencia e innovación</span>.</p>
  </div>
  <div  class='col-12 row mt-3'>
   <div class='col-2 d-flex justify-content-lg-end'>
    <img class='icoServic' src='assets/img/servIconGris.svg' alt='icono'>
   </div>
   <div class='col-10'>
    <p class='txt11px'>Bajo un estricto código de ética, conducta y confidencialidad por el cual nuestros empleados y accionistas están sujetos a asegurar los más altos estándares de calidad y fiabilidad que demandan nuestros clientes.</p>
   </div>

   <div class='col-2 d-flex justify-content-lg-end'>
    <img class='icoServic' src='assets/img/servIconOrange.svg' alt='icono'>
   </div>
   <div class='col-10'>
    <p class='txt11px'>Nos distinguimos en el mercado gracias a una profunda visión de nuestros clientes y el sector, ofreciendo soluciones innovadoras y personalizadas de seguros y reaseguros.</p>
   </div>
  </div>
 </div>
</section>

<div class='d-flex justify-content-center'>
 <hr class='lineSev mt-2'>
</div>

<!-- Servicios -->

<section class='container mb-5'>
  <h3 class='text-uppercase txtBold text-center mb-lg-3'>Para ti,<br><span class='txtcomf'>soluciones sólidas</span><br>personalizadas a tus necesidades</h3>

  <div class='row d-flex justify-content-center col-lg-11 mx-lg-auto'>

    <!-- Vehiculos -->
  <div class='col-11 col-md-5 col-lg-4 m-2 m-md-1 m-lg-0'>
  <div class='borderContSev' [id]='"btnCar"'>
      <div class='contServ p-2'>
      <img src='assets/img/car.svg' alt='seguro de vehiculos'>
      <div>
        <p class='text-center txtBold'>Para tu vehículo</p>
        <p>Ofrecemos diferentes opciones para que elijas el seguro de auto que más se ajuste a tus necesidades y presupuesto.</p>
      </div>

      <div class='row'>
        <div class='col-6'>
        <a class='mb-1 linkNo' (click)='goToform("vehiculo")'>Cotizar Aquí <img class='icoSmallSev' src='assets/img/shield.svg' alt='icono para cotizar'></a>
        </div>
        <div class='col-6 d-flex justify-content-end'>
        <a class='linkNo mb-1 text-end' (click)='goWhatapp(car)'>Escríbenos <img class='icoSmallSev' src='assets/img/wassap.svg' alt='icono whatspp'></a>
        </div>
      </div>
      </div>
    </div>
  </div>

  <!-- viajes -->
  <div class='col-11 col-md-5 col-lg-4 m-2 m-md-1 m-lg-0'>
  <div class='borderContSev' [id]='"btnTravel"'>
  <div class='contServ p-2'>
    <img [src]='"../../assets/img/travel.svg"' [alt]='"seguro de viajes"'>
    <div>
    <p class='text-center txtBold'>Para tus viajes</p>
    <p>Disfruta tu viaje con la tranquilidad de que estás protegido a través de una amplia red de médicos y centros, disponibles las 24 horas.</p>
    </div>

    <div class='row'>
    <div class='col-6'>
      <a class='mb-1 linkNo' (click)='goToform("viajes")'>Cotizar Aquí <img class='icoSmallSev' [src]='"../../assets/img/shield.svg"' [alt]='"icono para cotizar"'></a>
    </div>
    <div class='col-6 d-flex justify-content-end'>
      <a class='linkNo mb-1 text-end'  (click)='goWhatapp(viaje)'>Escríbenos <img class='icoSmallSev' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
    </div>
    </div>
  </div>
  </div>
  </div>

  <!-- propiedades -->
  <div class='col-11 col-md-5 col-lg-4 m-2 m-md-1 m-lg-0'>
  <div class='borderContSev' [id]='"btnProp"'>
  <div class='contServ p-2'>
    <img [src]='"../../assets/img/home.svg"' [alt]='"seguro propiedades"'>
    <div>
    <p class='text-center txtBold'>Para tus propiedades</p>
    <p>Protege tus propiedades ante las pérdidas o daños ocasionados a consecuencia de eventos inesperados.</p>
    </div>

    <div class='row'>
    <div class='col-6'>
      <a class='mb-1 linkNo' (click)='goToform("propiedad")'>Cotizar Aquí <img class='icoSmallSev' [src]='"../../assets/img/shield.svg"' [alt]='"icono para cotizar"'></a>
    </div>
    <div class='col-6 d-flex justify-content-end'>
      <a class='linkNo mb-1 text-end' (click)='goWhatapp(prop)'>Escríbenos <img class='icoSmallSev' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
    </div>
    </div>
  </div>
  </div>
  </div>

   <!-- salud -->
  <div class='col-11 col-md-5 col-lg-4 m-2 m-md-1 m-lg-3'>
  <div class='borderContSev' [id]='"btnSalud"'>
  <div class='contServ p-2'>
    <img [src]='"../../assets/img/health.svg"' [alt]='"seguro salud"'>
    <div>
    <p class='text-center txtBold'><small>Para tu salud</small></p>
    <p>Cuenta con respaldo económico ante las posibles consecuencias de un accidente o enfermedad, asegurando protegerte en los gastos de salud y pronto acceso a las redes de servicios.</p>
    </div>

    <div class='row'>
    <div class='col-6'>
      <a class='mb-1 linkNo' (click)='goToform("salud")'>Cotizar Aquí <img class='icoSmallSev' [src]='"../../assets/img/shield.svg"' [alt]='"icono para cotizar"'></a>
    </div>
    <div class='col-6 d-flex justify-content-end'>
      <a class='linkNo mb-1 text-end' (click)='goWhatapp(salud)'>Escríbenos <img class='icoSmallSev' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
    </div>
    </div>
  </div>
  </div>
  </div>

    <!-- vida -->
  <div class='col-11 col-md-5 col-lg-4 m-2 m-md-1 m-lg-3'>
    <div class='borderContSev' [id]='"btnVida"'>
     <div class='contServ p-2'>
      <img [src]='"../../assets/img/family.svg"' [alt]='"seguro de vida"'>
      <div>
       <p class='text-center txtBold'>Para tu vida</p>
       <p>Un seguro de vida les permite tranquilidad a los tuyos ante la posibilidad de que llegues a faltarle, garantizandoles su estabilidad economica, para hacerse cargo de los costos de subsistencia.</p>
      </div>

      <div class='row'>
       <div class='col-6'>
        <a class='mb-1 linkNo' (click)='goToform("vida")'>Cotizar Aquí <img class='icoSmallSev' [src]='"../../assets/img/shield.svg"' [alt]='"icono para cotizar"'></a>
       </div>
       <div class='col-6 d-flex justify-content-end'>
        <a class='linkNo mb-1 text-end' (click)='goWhatapp(vida)'>Escríbenos <img class='icoSmallSev' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
       </div>
      </div>
     </div>
   </div>
  </div>

  </div>

  <div [ngClass]='"d-flex justify-content-center my-3"'>
  <hr [ngClass]='"lineSev mt-2"'>
  </div>




  <div [ngClass]='"row d-flex justify-content-center justify-content-lg-around"'>
     <!-- corporativo -->
   <div [ngClass]='"col-12 col-md-6 p-md-0 row d-flex justify-content-lg-center"'>
    <div [ngClass]='"col-12"'>
    <h3 [ngClass]='"text-uppercase txtBold text-center"'>Para ti, cliente corporativo</h3>
   </div>

   <div [ngClass]='"col-11 col-lg-9 m-2 borderContSev"' [id]='"btnCorpo"'>
    <div [ngClass]='"contServ p-2"'>
     <img [src]='"../../assets/img/corporativos.svg"' [alt]='"seguro de masivos"'>
     <div>
      <p [ngClass]='"text-center txtBold"'>Pymes, Grupos Empresariales, Industrias, Multinacionales, entre otros</p>
      <p>Ofrecemos a nuestros clientes asesoría personalizada para obtener las coberturas más competitivas y proteger tanto a la empresa, como también sus empleados.</p>
     </div>

     <div [ngClass]='"row"'>
      <div [ngClass]='"col-12 justify-content-end"'>
       <a [ngClass]='" mb-1 linkNo"' (click)='goWhatapp(corpo)'>Escríbenos <img [ngClass]='"icoSmallSev"' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
      </div>
     </div>
    </div>
   </div>
   </div>

   <!-- alternos -->
   <div [ngClass]='"col-12 col-md-6 p-md-0 row borderStart d-flex justify-content-lg-center"'>
    <div [ngClass]='"col-12 mt-4 mt-md-0"'>
    <h3 [ngClass]='"text-uppercase txtBold text-center"'>Canales Alternos,<br>Banca Seguros / Seguros Masivos</h3>
   </div>

     <div [ngClass]='"col-11 col-lg-9 m-2 borderContSev"' [id]='"btnAlte"'>
       <div [ngClass]='"contServ p-2 "'>
        <img [src]='"../../assets/img/alternos.svg"' [alt]='"canals alternos seguros"'>
        <div>
         <p [ngClass]='"text-center txtBold"'>Canales Alternos, Banca Seguros / Seguros Masivos</p>
         <p>Desarollamos productos de seguros para la venta en grandes volúmenes. Ponemos además a tu disposición nuestra propia plataforma digital para la gestión y administración de estos servicios.
         </p>
        </div>

        <div [ngClass]='"row"'>
         <div [ngClass]='"col-12 justify-content-end"'>
          <a [ngClass]='" mb-1 linkNo"' (click)='goWhatapp(alternos)'>Escríbenos <img [ngClass]='"icoSmallSev"' [src]='"../../assets/img/wassap.svg"' [alt]='"icono whatspp"'></a>
         </div>
        </div>
       </div>
     </div>
   </div>
  </div>
</section>
